/**
 * Workflow helper
 */
class WorkflowHelper {
  __getFlowStateByFlowName (object, workflowName = 'sale') {
    if (object && object.workflowState) {
      for (let i in object.workflowState) {
        if (object.workflowState[i].name === workflowName) {
          return object.workflowState[i]
        }
      }
    }
    return null
  }

  __getSubflowStateBySubflowName (workflowState, subflowName) {
    if (typeof workflowState === 'object' && workflowState.hasOwnProperty('subflow') && Array.isArray(workflowState.subflow)) {
      for (let i in workflowState.subflow) {
        if (workflowState.subflow[i].name === subflowName) {
          return workflowState.subflow[i]
        }
      }
    }
    return null
  }

  subflowActive (object, subflowName, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      return !!this.__getSubflowStateBySubflowName(flowState, subflowName)
    }
    return false
  }

  flowStatusIn (statuses, object, workflowName = 'sale') {
    return statuses.indexOf(this.getFlowStatus(object, workflowName)) > -1
  }

  getFlowStatus (object, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      return flowState.status
    }
    return flowState
  }

  getFlowStatusReason (object, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      return flowState.reason
    }
    return flowState
  }

  subflowStatusIn (statuses, object, subflowName, workflowName = 'sale') {
    return statuses.indexOf(this.getSubflowStatus(object, subflowName, workflowName)) > -1
  }

  getSubflowStatus (object, subflowName, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      let subflowState = this.__getSubflowStateBySubflowName(flowState, subflowName)
      if (subflowState) {
        return subflowState.status
      }
    }
    return null
  }

  getSubflowStatusReason (object, subflowName, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      let subflowState = this.__getSubflowStateBySubflowName(flowState, subflowName)
      if (subflowState) {
        return subflowState.reason
      }
    }
    return null
  }

  getSubflowPassed (object, subflowName, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      let subflowState = this.__getSubflowStateBySubflowName(flowState, subflowName)
      if (subflowState) {
        return subflowState.passed
      }
    }
    return []
  }

  getPassed (object, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      return flowState.passed
    }
    return []
  }

  isInPassed (passed, status) {
    let result = false
    if (Array.isArray(passed)) {
      for (let i in passed) {
        if (passed[i].label === status) {
          result = true
        }
      }
    }
    return result
  }

  getTransitions (object, workflowName = 'sale') {
    let flowState = this.__getFlowStateByFlowName(object, workflowName)
    if (flowState) {
      return flowState.transitions
    }
    return null
  }

  getTargetTransition (object, workflowName = 'sale') {
    let items = this.getTransitions(object, workflowName)
    for (let i in items) {
      if (items[i].is_target > 0) {
        return items[i]
      }
    }
    return null
  }
}

const workflowHelper = new WorkflowHelper()
export default workflowHelper
